import React, {useEffect} from "react";
import {useState} from "react";
import styles from "./Tabs.module.scss";


function Tabs(props) {
  const { children } = props;
  const [currentTab, setCurrentTab] = useState(0);
  const [headers, setHeaders] = useState();
  const [processedChildren, setProcessedChildren] = useState();

  useEffect(() => {
    const labels = children.map((child) => child.props.label);

    // Update headers with logic to switch tabs
    setHeaders(labels.map((l, i) => {
      const classes = [styles.tabHeader];
      if (i === currentTab) {
        classes.push(styles.current);
      }

      const onClick = () => setCurrentTab(i);

      return (
        <div className={classes.join(" ")} onClick={onClick} key={i}>
          <span className={styles.text}>{l}</span>
        </div>
      );
    }));

    // Update children, showing only current tab
    setProcessedChildren(children.map((child, i) => {
      const classes = [styles.tab];
      if (i === currentTab) {
        classes.push(styles.current);
      }
      
      return <div className={classes.join(" ")} key={i}>{child}</div>;
    }));
  }, [children, currentTab]);

  return (
    <div className={styles.tabsContainer}>
      <div className={styles.tabsHeader}>
        { headers }
      </div>
      <div className={styles.tabs}>
        { processedChildren }
      </div>
    </div>
  );
}

export default Tabs;